export default __webpack_public_path__ + "static/media/Gesture_white_Pat-14.a0838730.svg";